// ============================================================================
// SPANISH TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Datos fascinantes sobre la Biblia

export const bibleFacts = [
  {
    category: "estructura",
    text: "La Biblia contiene 66 libros escritos por más de 40 autores diferentes a lo largo de aproximadamente 1500 años",
    source: "Estructura bíblica canónica"
  },
  {
    category: "tamaño",
    text: "La Biblia contiene 31,173 versículos, 1,189 capítulos y aproximadamente 783,137 palabras en su versión original",
    source: "Análisis textual bíblico"
  },
  {
    category: "traducción",
    text: "La Biblia ha sido traducida completamente o parcialmente a más de 3,000 idiomas, lo que la convierte en el libro más traducido del mundo",
    source: "Sociedades Bíblicas Unidas"
  },
  {
    category: "versículo",
    text: "El versículo más corto de la Biblia es 'Jesús lloró' (Juan 11:35), mientras que el más largo es Ester 8:9",
    source: "Análisis textual bíblico"
  },
  {
    category: "popularidad",
    text: "La Biblia es el libro más vendido de todos los tiempos, con más de 5 mil millones de copias distribuidas",
    source: "Registros de publicación editorial"
  },
  {
    category: "historia",
    text: "Los Rollos del Mar Muerto, descubiertos en 1947, contienen manuscritos bíblicos que datan de más de 2,000 años",
    source: "Arqueología bíblica"
  },
  {
    category: "centro",
    text: "El capítulo central de la Biblia es el Salmo 118, y el versículo central es el Salmo 118:8",
    source: "Estructura numérica bíblica"
  }
];

export default bibleFacts;
